module.exports = __webpack_public_path__ + "img/serive5.fc43f0d8.jpg";